import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function OpeningStory() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const paragraphs = ['Son las 11 de la noche.', 'Llevas horas despierto. O quizás acabas de acostarte hace veinte minutos y ya sabes, con esa certeza que ojalá no tuvieras, que esta noche va a ser otra batalla.', 'Tu cuerpo está agotado. Tus ojos pesan. Pero tu mente... tu mente no para.', 'Repasa la conversación de esta mañana. Anticipa lo de mañana. Crea problemas que todavía no existen. Y cuando intentas pararlo, el simple acto de intentar pararlo lo alimenta más.', 'No es que seas débil. No es que estés loco. Es que nadie te enseñó a apagar el interruptor.'];
  return <section ref={ref} className="w-full px-6 py-10" data-id="element-199">
      <div className="max-w-3xl mx-auto" data-id="element-200">
        {paragraphs.map((text, index) => <motion.p key={index} initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        delay: index * 0.2,
        duration: 0.6
      }} className={`text-lg md:text-xl mb-6 ${index === 0 ? 'text-2xl md:text-3xl font-playfair font-semibold' : ''} ${index === paragraphs.length - 1 ? 'text-amber-gold font-medium' : ''}`} data-id="element-201">
            {text}
          </motion.p>)}
      </div>
    </section>;
}